export default "__VITE_ASSET__CTVmGEqn__"